<template>
  <div class="game-progressbar">
    <span class="game-progressbar__circle-shadow" />

    <span class="game-progressbar__circle">
      <img src="/img/misc/leaf.png" alt="leaf image">
    </span>

    <span class="game-progressbar__container">
      <span
        class="game-progressbar__progress"
        :style="{ width: `${(($store.state.coins + 1) / ($game.state.limitCoins + 1)) * 100}%` }"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'GameProgressbar',
};
</script>

<style lang="scss" scoped>
.game-progressbar {
  position: relative;

  justify-content: flex-start;

  &,
  &__circle {
    display: flex;
    align-items: center;
  }

  &__circle,
  &__circle-shadow {
    width: 55px;
    height: 55px;

    border-radius: 50%;

    @include mq($until: mobileL) {
      width: 35px;
      height: 35px;
    }
  }

  &__circle {
    position: relative;
    background-color: $color-yellow;

    justify-content: center;

    img {
      display: block;
      position: relative;
      width: 70%;
    }

    z-index: 5;
  }

  &__circle-shadow {
    position: absolute;
    top: 2px;
    left: 2px;
    background-color: $color-black;
  }

  &__container {
    display: inline-block;
    position: relative;
    width: 100px;
    height: 20px;
    margin-top: 5px;
    margin-left: -15px;

    background-color: $color-black;
    transform-origin: left center;
    transition: transform 0.1s linear;

    border: 3px solid $color-yellow;
    border-radius: 15px;
    box-shadow: $button-shadow;

    .game-progressbar__progress {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      border-radius: 15px;
      @include sky-gradient(90deg);

      transition: width 0.35s ease-out;
    }

    @include mq($until: mobileL) {
      width: 50px;
      height: 15px;
      margin-top: 2px;
      margin-left: -10px;

      border: 1px solid $color-yellow;
    }
  }
}
</style>
